import { DndContext } from "@dnd-kit/core";
import cn from "classnames";
import { If } from "components";
import { t } from "i18next";
import Skeleton from "react-loading-skeleton";

import { TableBody, TableHead } from "./atoms";
import { useTableDragDrop } from "./hooks";
import { ItemsTableDragDropProps } from "./ItemsTableDragDrop.types";

import styles from "./ItemsTableDragDrop.module.scss";

const ItemsTableDragDrop = <TData extends { id: string }, TValue>({
  className,
  columns,
  data,
  sorting,
  isLoading,
  setSorting,
  onRowClick,
  emptyListMessage = "There are no items matching your choice",
  skeletonHeight = 65,
  isDragDisabled = false,
  keyForReorder,
  onChange
}: ItemsTableDragDropProps<TData, TValue>) => {
  const { table, sensors, collisionDetection, modifiers, onDragEnd } =
    useTableDragDrop({
      keyForReorder,
      columns,
      data,
      sorting,
      setSorting,
      onChange
    });

  return (
    <>
      <DndContext
        collisionDetection={collisionDetection}
        modifiers={modifiers}
        onDragEnd={onDragEnd}
        sensors={sensors}
      >
        <table className={cn(styles.table, className)}>
          <TableHead table={table} />
          <TableBody
            table={table}
            dataIds={data}
            onRowClick={onRowClick}
            isDragDisabled={isDragDisabled}
          />
        </table>
      </DndContext>

      <If condition={isLoading}>
        <Skeleton
          height={skeletonHeight}
          className={styles.skeleton}
          count={5}
        />
      </If>

      <If condition={data.length === 0 && !isLoading}>
        <div className={styles.emptyDataMessage}>{t(emptyListMessage)}</div>
      </If>
    </>
  );
};

export default ItemsTableDragDrop;
